import { render, staticRenderFns } from "./package-files-widget.vue?vue&type=template&id=f261daaa&"
import script from "./package-files-widget.vue?vue&type=script&lang=js&"
export * from "./package-files-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports